"use client";

import { useRef, useState } from "react";

export type SendFollowUp = (message: string) => boolean;

export function useSupportAsk() {
  const [query, setQuery] = useState("");
  const [askedQuestion, setAskedQuestion] = useState<string | null>(null);
  const sendFollowUpRef = useRef<SendFollowUp | null>(null);

  function ask(question: string) {
    const trimmed = question.trim();
    if (!trimmed) return;
    if (askedQuestion === null) setAskedQuestion(trimmed);
    else if (!sendFollowUpRef.current?.(trimmed)) return;
    setQuery("");
  }

  function startOver() {
    setAskedQuestion(null);
    setQuery("");
  }

  return { query, setQuery, askedQuestion, sendFollowUpRef, ask, startOver };
}
